import { Identifier } from '@/components/question/view/types';

export const getDomByTestId = (testId: string) =>
  document.querySelector<HTMLElement>(`[data-testid="${testId}"]`);

export const getChipDom = (id: Identifier) => getDomByTestId(`chip-${id}`);

export const getSlotDom = (slotId: string) => getDomByTestId(`slot-${slotId}`);
